import type { AdminDetails, Category } from 'app/src/services/welfareportal/companyagreement-api'

// eslint-disable-next-line import/no-named-as-default
import z from 'zod'

export const adminDetailsSchema: z.ZodType<AdminDetails> = z.object({
  createdBy: z.string(),
  createdOn: z.string(),
  lastModifiedBy: z.string(),
  lastModifiedOn: z.string(),
})

export const categorySchema: z.ZodType<Category & { serviceCategory?: string }> = z.object({
  categoryId: z.string(),
  parentCategoryId: z.string().optional(),
  categoryName: z.string(),
  description: z.string(),
  mainImage: z.string().optional(),
  weight: z.number().optional(),
  children: z.array(z.any()),
  adminDetails: adminDetailsSchema.optional(),
  displayMode: z.record(z.string(), z.string()).optional(),
  serviceCategory: z.string().optional(),
})
